module.exports = __webpack_public_path__ + "static/media/optout_2.4f8105a6.svg";